module.exports = __webpack_public_path__ + "img/scene_mojito_big@2x.3db83529.png";